import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const topPersonaAnalysisSlice = createApi({
  reducerPath: "analysis_top_persona",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["top_persona"],
  endpoints: (build) => ({
    getTopPersonaExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=persona&view=expand&page=0&size=10`,
        url: `/bank/${orgId}/dashboard/${payload.requid}/persona/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
  }),
});

export const { useGetTopPersonaExpandedQuery } = topPersonaAnalysisSlice;
